import { jsx } from 'react/jsx-runtime';
import styles from './index.module.scss.js';

const Placeholder = ({ categoryID, subject, assetsBase }) => {
    return (jsx("img", { src: `${assetsBase}/static/icons/categories/${categoryID}.svg`, alt: subject, className: styles.placeholder, loading: "lazy", decoding: "async" }));
};

export { Placeholder };
//# sourceMappingURL=Placeholder.js.map
